export const FETCH_GOALS_BY_WORKSPACE = 'FETCH_GOALS_BY_WORKSPACE';
export const GET_CURRENT_PERCENTAGE = 'GET_CURRENT_PERCENTAGE';
export const FETCH_USER = 'FETCH_USER';
export const USER_SIGNED_IN = 'USER_SIGNED_IN';
export const USER_SIGNED_OUT = 'USER_SIGNED_OUT';